import React from "react";
import "../../styles/SalesFunnel.css";
import { Link } from "react-router-dom";
import AIservice from "../../Page-section/ai-driven-marketing/AIservice";
import Faq from "../../Page-section/ai-driven-marketing/Faq";
import {
  FaLightbulb,
  FaUsers,
  FaCode,
  FaCogs,
  FaAward,
  FaPaperPlane,
} from "react-icons/fa";
import Portfolio from "../../components/portfolio";

const AIprocess = () => {
  const point = [
    "Detect insects faster",
    "Improve check coverage",
    "Reduce checking out time",
    "Enhance software fine",
  ];
  const points = [
    "Healthcare",
    "Finance",
    "E-commerce",
    "Education",
    "IT & Software",
  ];

  const steps = [
    {
      id: 1,
      title: " Requirement Analysis",
      color: "green",

      icon: <FaLightbulb />,
      desc: "We start through information your enterprise desires, demanding situations, and present day workflows. ",
    },
    {
      id: 2,
      title: "Strategy & Planning",
      color: "#0868a0",
      icon: <FaUsers />,
      desc: "Based for your requirements, we create a customized automation strategy the usage of ai powered automation gear. ",
    },
    {
      id: 3,
      title: "AI Solution Development",
      color: "green",
      icon: <FaCode />,
      desc: "Our team develops clever answers which includes ai chatbots for customer service, workflow automation systems, and clever gear tailor-made on your desires.",
    },
    {
      id: 4,
      title: "Testing & Quality Assurance",
      color: "#0868a0",
      icon: <FaCogs />,
      desc: "We use superior ai for software testing to make sure that all automation systems feature easily and effectively. ",
    },
    {
      id: 5,
      title: "Deployment & Integration",
      color: "green",
      icon: <FaAward />,
      desc: "Once examined, we installation the answer and integrate it seamlessly into your current systems.",
    },
    {
      id: 6,
      title: "Continuous Optimization",
      color: "#0868a0",
      icon: <FaPaperPlane />,
      desc: "Using computerized gadget mastering, we constantly display and optimize your automation structures. ",
    },
  ];
  return (
    <section className="sf-wrapper">
      <div className="sf-sidebar">
        <div className="sf-card">
          <h2>Our Services</h2>

          <ul className="sf-service-list">
              <li className="active">
              <Link to="/ai-automation-services">
                AI Automation Services
              </Link>
            </li>
            <li>
              <Link to="/web-development-company-in-noida">Web Development</Link>
            </li>
            <li>
              <Link to="/web-design-services">Web Design</Link>
            </li>
            <li>
              <Link to="/seo-agency-noida">SEO Services</Link>
            </li>
              <li>
              <Link to="/social-media-marketing-services">Social Media Marketing</Link>
            </li>
            <li>
              <Link to="/content-marketing-services">Content Marketing</Link>
            </li>
          
          
            <li>
              <Link to="/lead-generation-services">Lead Generation</Link>
            </li>
            <li>
              <Link to="/sales-funnel-optimization">
                Sales Funnel Optimization
              </Link>
            </li>
            <li>
              <Link to="/branding-agency-noida">Branding Services</Link>
            </li>
            <li>
              <Link to="/business-automation-services">
                Business Automation
              </Link>
            </li>
            <li>
              <Link to="/resources">Resources</Link>
            </li>
          </ul>
        </div>

        <div className="sf-card">
          <h2>Contact Info</h2>

          <div className="sf-contact">
            <p>Address :- Sector-62, Noida, India</p>
            <p>
              Phone :- <br />
              <a href="tel:+918368327503"> +91 8368327503</a> |{" "}
              <a href="tel:+919319563429"> +91 9319563429</a>
            </p>
            <p>
              Email :- <br />
              <a href="mailto:connect@empowerweb.in">connect@empowerweb.in</a>
            </p>
          </div>
        </div>
                <Portfolio />

      </div>
      <div className="sf-main-content">
        <section className="why-container">
          <div className="why-content">
            <h2>What Are AI Automation Services?</h2>

            <p>
              Ai automation offerings consult with the usage of artificial
              intelligence technology to automate commercial enterprise
              strategies and duties without human intervention. These services
              move past conventional automation via getting to know from
              statistics and improving overall performance through the years.
            </p>
            <p>
              With the help of <b>ai powered automation</b>, corporations can
              streamline operations, decrease mistakes, and growth productivity.
              AI-pushed systems can cope with complex strategies consisting of
              records evaluation, customer support, and checking out with high
              accuracy and velocity.
            </p>
          </div>
        </section>
        <section className="freight-container">
          <div className="freight-content">
            <h3>Key Benefits of AI Automation</h3>
            <p>
              Implementing ai automation offerings gives numerous blessings:
            </p>
            <div className="freight-boxes">
              <div className="box">
               
                <div>
                  <h4>Increased operational efficiency</h4>
                </div>
              </div>
              <div className="box">
              
                <div>
                  <h4>Reduced manual errors</h4>
                </div>
              </div>
              <div className="box">
              
                <div>
                  <h4>Faster decision-making </h4>
                </div>
              </div>
            </div>
            <br />
            <p>
              Businesses that adopt <b>ai powered automation</b> gain a
              significant edge by improving productivity and delivering
              consistent results.
            </p>
          </div>
        </section>
        <AIservice />
        <section className="work-process-section">
          <h3 className="work-title">Our AI Automation Process</h3>
          <p className="work-subtitle">
            We comply with a established and statistics-pushed technique to
            supply effective ai automation services that streamline your
            enterprise operations and enhance performance. Our technique
            specializes in identifying automation possibilities, implementing
            wise answers.
          </p>

          <div className="process-wrapper">
            {/* STEP LABELS */}
            <div className="process-line">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className="process-step"
                  style={{ backgroundColor: step.color }}
                >
                  {step.title}
                </div>
              ))}
            </div>

            {/* STEP DETAILS */}
            <div className="process-grid">
              {steps.map((step) => (
                <div className="process-item" key={step.id}>
                  <div
                    className="process-iconv"
                    style={{ borderColor: step.color, color: step.color }}
                  >
                    {step.icon}
                  </div>
                  <h3 className="process-num" style={{ color: step.color }}>
                    {step.id.toString().padStart(2, "0")}
                  </h3>
                  <p className="process-text">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="why-container">
          <div className="why-content">
            <h2>AI for Software Testing</h2>

            <p>
              Software trying out is a crucial a part of development, and{" "}
              <b>ai for software testing</b> checking out is revolutionizing
              this method. Traditional trying out techniques can be time-eating
              and at risk of errors, but AI-driven testing equipment can
              automate and optimize the whole method. Using ai for software
              testing checking out, agencies can:
            </p>

            <ul>
              {point.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>

            <p>
              AI enables in predictive analysis and ensures that applications
              perform correctly before deployment.
            </p>
          </div>
        </section>
        <section className="why-container">
          <div className="why-content">
            <h2>Industries Benefiting from AI Automation</h2>

            <p>
              Almost every industry is benefiting from ai automation services,
              including:
            </p>

            <ul>
              {points.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>

            <p>
              From using <b>ai chatbots for customer service</b> in e-commerce
              to implementing ai for software testing in IT companies, AI is
              driving innovation across sectors.
            </p>
          </div>
        </section>
        <section className="benefits-section">
          <div className="container">
            <div className="header">
              <div className="title-row">
                <h3>Why Choose Our AI Automation Services?</h3>

                <p>
                  Choosing the right partner for ai automation services is
                  essential for success. Here’s why businesses trust us:
                </p>
              </div>
            </div>

            <div className="cards">
              <div className="card">
                <h3>Expertise in ai powered automation</h3>
              </div>
              <div className="card">
                <h3>Advanced tools for ai for software testing</h3>
              </div>
              <div className="card">
                <h3>Customized AI solutions</h3>
              </div>
              <div className="card">
                <h3>Proven results</h3>
              </div>
              <div className="card">
                <h3>Dedicated support</h3>
              </div>
            </div>
          </div>
        </section>
        <Faq />
        <section className="operations-wrapper">
          <div className="operations-left">
            <h3>Get Started with AI Automation Today</h3>
          </div>
          <div className="operations-right">
              <p>
                If you need to streamline operations, improve efficiency, and
                improve boom, now could be the time to spend money on ai
                automation services. By leveraging ai powered automation, you
                may rework your enterprise methods and obtain lengthy-time
                period achievement.
              </p>
          </div>
        </section>
      </div>
    </section>
  );
};

export default AIprocess;
